import { render, staticRenderFns } from "./ResearchPoliciesAndNotices.vue?vue&type=template&id=278fdd8d&"
import script from "./ResearchPoliciesAndNotices.vue?vue&type=script&lang=js&"
export * from "./ResearchPoliciesAndNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports